export default __webpack_public_path__ + "static/media/Mobile Menu.aa8fba3d.svg";